import React from "react";
import * as dc from "dc";
import * as d3 from "d3";
import {interpolateSpectral} from "d3-scale-chromatic";
import "leaflet/dist/leaflet.css";
import "leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.webpack.css"; // Re-uses images from ~leaflet package
import * as L from "leaflet";
import "leaflet-defaulticon-compatibility";
import * as dc_leaflet from "dc.leaflet";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import reductio from "reductio";
import {ChartTemplate} from "./chartTemplate";

const mapChartChartFunc = (divRef, ndx, geojson) => {
    const countyCode = ndx.dimension((d) => d.baseTbCode);
    const grp = countyCode.group().reduceCount();

    var choromap = dc_leaflet.choroplethChart(divRef).dimension(countyCode).group(grp).width(385).height(530).center([0.34, 37.51]).zoom(5.5).geojson(geojson).colors(d3.scaleSequential().domain([1, 47]).interpolator(d3.interpolateTurbo)).colorAccessor(function (d) {
        return d.key;
    }).featureKeyAccessor(function (feature) {
        return feature.properties.baseTbCode;
    }).popupMod("ctrlCmd").renderPopup(true).popup(function (d, feature) {
        return feature.properties.baseTbCode + " : " + d.value;
    });

    return choromap;
};

export const ChoroplethmapChart = (props) => (
    <ChartTemplate chartFunction={mapChartChartFunc}
        title = "Map View"
    />);
